export default "__VITE_ASSET__BBQTpJjp__"